// extracted by mini-css-extract-plugin
export var option = "_8o-0";
export var optionCard = "_8o-f";
export var optionContent = "_8o-g";
export var optionIcon = "_8o-i";
export var optionIconBox = "_8o-h";
export var optionLabel = "_8o-j";
export var optionPill = "_8o-m";
export var optionPillBadge = "_8o-p";
export var optionPillIcon = "_8o-n";
export var optionPillLabel = "_8o-o";
export var optionRadio = "_8o-k";
export var optionRadioInner = "_8o-l";
export var optionReveal = "_8o-2";
export var optionRevealDelay0 = "_8o-3";
export var optionRevealDelay1 = "_8o-4";
export var optionRevealDelay10 = "_8o-d";
export var optionRevealDelay11 = "_8o-e";
export var optionRevealDelay2 = "_8o-5";
export var optionRevealDelay3 = "_8o-6";
export var optionRevealDelay4 = "_8o-7";
export var optionRevealDelay5 = "_8o-8";
export var optionRevealDelay6 = "_8o-9";
export var optionRevealDelay7 = "_8o-a";
export var optionRevealDelay8 = "_8o-b";
export var optionRevealDelay9 = "_8o-c";
export var optionSelected = "_8o-1";